import { Button } from '@mui/material';

export default function CannotDoFaceCheckOption({ onSkip }: Readonly<{ onSkip?: () => void }>) {
  return (
    <Button onClick={() => onSkip?.()} data-action="skip-face-check">
      I cannot do a face check right now
    </Button>
  );
}
